import React from 'react'
import { Box, Button } from '@mui/material'

export interface FloatingSaveCancelButtonsProps {
  /** Show the floating panel (e.g. when form is dirty) */
  visible: boolean
  /** Save clicked */
  onSave: () => void | Promise<void>
  /** Cancel clicked */
  onCancel: () => void
  /** Disable both buttons (e.g. while saving) */
  saving?: boolean
  /** Optional save button label (default: "Save") */
  saveLabel?: string
  /** Optional cancel button label (default: "Cancel") */
  cancelLabel?: string
}

/**
 * Floating save/cancel action bar for content detail pages.
 * Renders fixed bottom-right; visibility and behavior are controlled via props.
 */
function FloatingSaveCancelButtons ({
  visible,
  onSave,
  onCancel,
  saving = false,
  saveLabel = 'Save',
  cancelLabel = 'Cancel',
}: FloatingSaveCancelButtonsProps) {
  return (
    <Box
      className="content-detail__action-buttons"
      sx={{
        position: 'fixed',
        bottom: visible ? '20px' : '-100px',
        right: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 1000,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(8px)',
        padding: '16px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.3s ease',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        minWidth: '200px',
      }}
    >
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          disabled={saving}
          sx={{
            flex: 1,
            minWidth: '100px',
            height: '42px',
            fontSize: '0.95rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            '&:hover': {
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
            },
          }}
        >
          {saving ? 'Saving...' : saveLabel}
        </Button>
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={saving}
          sx={{
            flex: 1,
            minWidth: '100px',
            height: '42px',
            fontSize: '0.95rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '8px',
          }}
        >
          {cancelLabel}
        </Button>
      </Box>
    </Box>
  )
}

export default FloatingSaveCancelButtons
